import { Component, Input, OnInit, forwardRef } from '@angular/core';
import { AdditionalDetail } from '../shared/model/ui/additional-detail';
import { Validators, FormBuilder, UntypedFormGroup, UntypedFormControl, ReactiveFormsModule } from '@angular/forms';
import { GlobalConstants } from "../shared/global-constants";
import { CmElement, ContentType } from '../shared/model/cm/managed-content.model';
import { ManagedContentService } from '../shared/service/managed-content.service';
import { FormControlUtilitiesService } from '../shared/service/form-control-utilities.service';
import { UserSessionService } from '../shared/service/user-session.service';
import { CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';

import { MonthPickerComponent } from '../month-picker/month-picker.component';
import { ButtonToggleComponent } from '../button-toggle/button-toggle.component';

@Component({
  selector: 'app-generic-form',
  standalone: true,
  imports: [ReactiveFormsModule, MonthPickerComponent, forwardRef(() => ButtonToggleComponent)],
  templateUrl: './generic-form.component.html',
  styleUrls: ['./generic-form.component.scss'],
  providers: [],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class GenericFormComponent implements OnInit {
  @Input() control: AdditionalDetail;
  @Input() parentKey: string;
  @Input() parentForm: UntypedFormGroup;

  public maxLength: number = GlobalConstants.MAX_LENGTH_GENERIC_INPUT;
  public formNumber: string = this.userSessionService.data.formNumber;
  public newFormControl: UntypedFormControl;
  public isGenericDynamicForm: boolean = this.userSessionService.data.isGenericDynamicForm;

  public fieldName: string = "";
  public timeInMilliseconds: string;
  
  requiredElement: CmElement = this.cmService.getContentById(ContentType.ELEMENT, 'required-error');

  constructor(private fb: FormBuilder,
    private cmService: ManagedContentService,
    public formControlUtilitiesService: FormControlUtilitiesService,
    private userSessionService: UserSessionService) { }

  ngOnInit(): void {
  if (this.control.controlType === 'input') {

    if (
      this.isGenericDynamicForm &&
      this.control.label.toLowerCase() === 'treatment'
    ) {
      this.newFormControl = this.fb.control('', [
        Validators.required,
        Validators.min(1),
        Validators.maxLength(GlobalConstants.MAX_LENGTH_GENERIC_TREATMENT),
        Validators.pattern(/^(?!-)[a-zA-Z0-9].*/)
      ]);
      this.maxLength = GlobalConstants.MAX_LENGTH_GENERIC_TREATMENT;

    } else if (this.control.label.toLowerCase() === 'condition') {

      this.newFormControl = this.fb.control('', [
        Validators.required,
        Validators.pattern(/^(?!-)[a-zA-Z0-9].*/)
      ]);

    } else {
      this.newFormControl = this.fb.control('', [
        Validators.required,
        Validators.min(1),
        Validators.maxLength(GlobalConstants.MAX_LENGTH_GENERIC_INPUT),
        Validators.pattern(/^(?!-)[a-zA-Z0-9].*/)
      ]);
    }

    if (this.parentForm) {
      if (this.parentForm.contains(this.control.key)) {
        // EDIT CASE — update validators
        const existingControl = this.parentForm.get(this.control.key);
        existingControl?.setValidators(this.newFormControl.validator);
        existingControl?.updateValueAndValidity();
      } else {
        // CREATE CASE
        this.parentForm.addControl(this.control.key, this.newFormControl);
      }
    }
  }

  const today = new Date();
  this.timeInMilliseconds = today.getTime().toString();

  this.disableAutoFill();
}

  private disableAutoFill(){
    this.fieldName = this.timeInMilliseconds + "-" + this.control.key;
  }

  // ngOnDestroy removed - empty lifecycle methods violate linting rules
  // DO NOT remove control from parent form - this causes data loss during navigation
  // The parent form should manage its own controls' lifecycle

  inputLeaveEvent(event, key: string) {
    const inputValue = event.target.value;
    this.parentForm.get(key).markAsTouched();
    this.parentForm.controls[key].setValue(inputValue.toString().trim());
    this.parentForm.updateValueAndValidity();
  }
}